<template>
  <div class="index">
    
    <topNav></topNav>
    
    <div class="top" :style="{'background-image':'url('+aboutUsNav[curAbout].bg+')','position':'relative','width':'100%','height':'600px','background-size':'auto 100%','background-position':'0px 0px'}" >
      <ul class="about_us_nav">
        <li @click="showAbout(0)" :class="[curAbout==0?'itemActive':'itemNoActive']">{{aboutUsNav[0].name}}</li>
        <li @click="showAbout(1)" :class="[curAbout==1?'itemActive':'itemNoActive']">{{aboutUsNav[1].name}}</li>
        <li @click="showAbout(2)" :class="[curAbout==2?'itemActive':'itemNoActive']" style="border-right:none;">{{aboutUsNav[2].name}}</li>
        <li @click="showAbout(3)" :class="[curAbout==3?'itemActive':'itemNoActive']" style="border-right:none;">{{aboutUsNav[3].name}}</li>
     </ul>    
    </div>


             <!--<img src="static/china_real_estate_industry_green_supply_chain_action.png" style="position:absolute;left:25px;top:150px;width:50%;" />-->
    <div style="position:absolute;left:25px;top:150px;width:68%;text-align:left;" class="brief_1 Impact" >Green Supply Chain Action in China’s Real Estate Industry</div>

    <!--<img src="static/under_top_logo.png" style="position:absolute;left:25px;top:200px;width:150px;" />-->

    <div style="position:absolute;left:25px;top:260px;width:55%;text-align:left;" class="brief_1 Impact"  v-if="$store.state.language === 'cn'">中国房地产行业<br/>绿色供应链行动</div>




    

     


    <pageLocation :currentLocation="curPage"></pageLocation>



    <div class="aboutUs" v-if="curAbout==0" style="width:100%;height:auto;margin:120px auto 0px auto;" >
      <!-- aboutUs start -->
      
     <div style="width:80%;margin:0 auto"><img src='static/participation_guide_en_title.png' style="width:100px;display:block;margin:0 auto;"></div>
     <div  v-if="$store.state.language === 'cn'" style="width:80%;margin:0 auto"><img src='static/about_us_page_about_us_ch_text.png' style="width:100px;display:block;margin:10px auto auto auto;"></div>
     
     <div style="width:80%;margin:20px auto">
         <!-- <div style="text-align:left;" class="joinUs" v-html="curArticleContent.content.replaceAll('/uploadfile','http://gsc.see.org.cn/uploadfile')"></div>  -->
         <div style="text-align:left;" class="joinUs" v-html="curArticleContent.content"></div> 
         
 
     </div>
 
 
 <!--aboutUs end-->
    </div>

    
    <div class="aboutUs" v-if="curAbout==1" style="width:100%;min-height:900px;margin:120px auto 0px auto;" >
     <!-- 行动宣言 start-->

      
     <div style="width:80%;margin:0 auto"><img src='static/contact_person_of_each_categor_en_title.png' style="width:180px;display:block;margin:0 auto;"></div>
     <div style="width:80%;margin:0 auto"><img src='static/contact_person_category_ch_title.png' style="width:100px;display:block;margin:10px auto auto auto;"></div>
     
     <div style="width:80%;margin:20px auto">
  
         <div style="text-align:left;" v-html="curArticleContent.content"></div> 
 
     </div>
 
 
 <!--行动宣言 end-->
    </div>

 



  


 
 
 


     <img src="static/about_us_bottom_img01.png" v-if="curAbout==0"  style="width:100%;display:block;margin-bottom:-2px;" />
    <!--底部组件-->
    <friendLinkAndFooter></friendLinkAndFooter>

 
 
  </div>
</template>


<script>
import { articleListByPage,articleDetail } from "@/api";
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import friendLinkAndFooter from '@/components/friendLinkAndFooter'
import topNav from '@/components/topNav'
import pageLocation from '@/components/pageLocation'
export default {
  name: 'joinUs',
  components:{
   topNav,friendLinkAndFooter,pageLocation
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      showNav:false,
      pages:1,
      //加入绿链
      curPage:'加入绿链',
      curAbout:0,
      curArticleCode:'WZNR201907291353270075',
      curArticleContent:{},
      
      aboutUsNav:[
        {'name':'参与指南','articleCode':'WZNR201907291353270075','catCode':'','bg':'static/join_us_top_bg.png'},
        {'name':'各品类联系人','articleCode':'WZNR201610311949190009','catCode':'','articleList':[],'bg':'static/join_us_top_bg.png'},
        {'name':'白、绿名单申报','articleCode':'WZNR201610311949190009','catCode':'','articleList':[],'bg':'static/join_us_category_concat_person.png'},
        {'name':'白名单申报','articleCode':'WZNR201610311949190009','catCode':'','articleList':[],'bg':'static/join_us_category_concat_person.png'}
      ]
    }
  },
  methods :{
 
      showAbout(n){
        if(n==2){
           window.location.href="http://greenlist.see.org.cn:8077/user/Login.aspx";
           return;
         }
         if(n==3){
           window.location.href="http://lxi.me/bg22z";
           return;
         }
         this.curAbout=n;
         
         this.curArticleCode=this.aboutUsNav[n].articleCode;
         this.articleDetail(this.curArticleCode);
         if(n==1){
          //如果是行动宣言查询下面的列表
         this.articleListByPage(this.aboutUsNav[n].catCode);

         }
      },
    articleDetail(articleCode){
      const params = {
          articleId: articleCode,
          isEn: this.$store.state.language === 'en' ? 1 : 0
        }
        articleDetail(params).then((res) => {
          // console.log(res);
          this.curArticleContent = res.data
          // this.list = [res.data]
          // this.content = 
        })



              setTimeout(() => {

     var o=document.querySelectorAll('.joinUs img');
 
      if(o){
        for(var i=0;i<o.length;i++){
          o[i].setAttribute("style","width:100%")
        }
      }
        
      }, 1000);

    },

   articleListByPage(catCode) {
        var that=this
            // console.log(this.dateY,' =====____');
            const params = {
              page: that.pages,
              catCode: encodeURIComponent(catCode),
              limit:99999,
              isEn: this.$store.state.language === 'en' ? 1 : 0
            };
            articleListByPage(params).then(res => {
              console.log(res.data);
              that.aboutUsNav[1].articleList = res.data.list;
            });
          }
  },
   mounted() {
     var that=this;

      //加载新闻
      this.articleDetail(this.curArticleCode);



       
      setTimeout(() => {

     var o=document.querySelectorAll('.joinUs img');
 
      if(o){
        for(var i=0;i<o.length;i++){
          o[i].setAttribute("style","width:100%")
        }
      }
        
      }, 1000);
 
 

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.brief_1{
    font-size: 20px;
    font-weight: 900;
    color: #fff;
    /* text-shadow: 0px 0px 1px #000; */
}
.Impact {
    font-family: Impact,微软雅黑;
}

.about_us_nav{margin:0px;padding:0px;display:flex;position:absolute;bottom:-20px;width:90%;left:5%;box-shadow:#ebebeb 5px 5px 5px 5px;}
.about_us_nav li{margin:0px;padding:0px;width:50%;text-align:center;height:35px;line-height: 35px;font-size: 12px;border-right:1px solid #89a128}

.show{display:block;}
.item{width:100%;height:50px;margin:0px;display:block;}
.itemActive{background:#89a128;color:#fff;}
.itemNoActive{background:#fff;color:#89a128;}
.hidden{display:none;}
.index{
  margin:0px;
  padding:0px;
  width: 100%;
  min-height: 960px;
}

.top{position:relative;width:100%;height:600px;background-size:auto 100%;background-position:0px 0px}


.navBox{width:150px;}
.navBox li{height:30px;}
.navBox li a{color:#fff;text-align:right;display:block;width:100%;text-decoration: none;}




.declarationItem{width:45%;float:left;overflow:hidden;margin:10px 2% 10px 2%;padding:0px;height:260px;}
.declarationItem li{margin:0px;padding:0px;}

 


 
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/joinUs.vue